<template>
  <iframe class="docs" :src="$route.params.url"></iframe>
</template>

<script>
export default {
  name: 'DocumentationView',
};
</script>

<style lang="scss">
.docs {
  display: block;
  width: 100vw;
  height: calc(100vh - 64px);
  border: 0;
  margin: 0 auto;
}
</style>